module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAKBJREFUOE9jdLm+7T8Dw38GBgZGBtIARA+jy/Wt/3//Fez//V3m4K/fss+JMYSN9bEkK+cTe1bm94WMIBd8+6ITwMr12Pn3N9m9hAwBa4aq5eK5sgFswIf3nubIErgMQVcjILj9JNwAkNPxGYJNDsMAmCEgp2ELC5BXkV2H1QCQRpAENgNAXkUWH64GgEKb7ECkKBopSkgUJmUqZCZKsjMAmt/xD6NrKIAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/square-point.png
// module id = qPzv
// module chunks = 1